export default (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;



// WEBPACK FOOTER //
// ./src/admin-on-rest/src/util/linkToRecord.js